import * as React from 'react';
import { FunctionComponent } from 'react';
import './GeneralMessagePreview.css';
import { GeneralMessagePreviewEmail } from './GeneralMessagePreviewEmail';
import { GeneralMessagePreviewPush } from './GeneralMessagePreviewPush';
import { GeneralMessagePreviewSms } from './GeneralMessagePreviewSms';
import { Attachment } from '../../models/generalMessage';
import { GeneralMessagePreviewTabs } from './GeneralMessagePreviewTabs';
import { AffectedUserList } from '../GeneralMessages/AffectedUserList/AffectedUserList';
import { HelpIconButton } from '../HelpIconButton/HelpIconButton';

interface Props {
  messageSmsText: string;
  messageEmailSubject: string;
  messageEmailBody: string;
  messagePushTitle: string;
  messagePushBody: string;
  messageAttachments: Attachment[];
  senderDisplayName?: string;
  affectedUsers?: any[];
  affectedUsersCount?: number;
  isResolvingRecipients?: boolean;
  isLoadingAffectedUserList?: boolean;
  onLoadAffectedUsers?: () => void;
  isEmailEnabled: boolean;
  isPushEnabled: boolean;
  isSmsEnabled: boolean;
  hideRecipients?: boolean;
  onHelpClick?: () => void;
}

export const GeneralMessagePreviewWithTabs: FunctionComponent<Props> = props => {
  const previews = [
    ...(props.isEmailEnabled
      ? [
          {
            title: 'Email',
            content: (
              <GeneralMessagePreviewEmail
                messageEmailSubject={props.messageEmailSubject}
                messageEmailBody={props.messageEmailBody}
                messageAttachments={props.messageAttachments}
                senderDisplayName={props.senderDisplayName}
              />
            )
          }
        ]
      : []),
    ...(props.isPushEnabled
      ? [
          {
            title: 'Push',
            content: (
              <GeneralMessagePreviewPush
                messagePushTitle={props.messagePushTitle}
                messagePushBody={props.messagePushBody}
              />
            )
          }
        ]
      : []),
    ...(props.isSmsEnabled
      ? [
          {
            title: 'SMS',
            content: <GeneralMessagePreviewSms messageSmsText={props.messageSmsText} />
          }
        ]
      : [])
  ];

  return (
    <div className={`gmPreview ${props.hideRecipients ? 'gmPreview--single' : ''}`}>
      <div className="gmPreview__main">
        <div className="gmPreview__heading">
          <div className="gmPreview__title">Message preview</div>
          {props.onHelpClick && <HelpIconButton onClick={props.onHelpClick} label="Need help with this step?" />}
        </div>
        <GeneralMessagePreviewTabs
          key={previews.map(preview => preview.title).join('|')}
          tabs={previews.map(preview => preview.title)}
        >
          {previews.map(preview => preview.content)}
        </GeneralMessagePreviewTabs>
      </div>
      {!props.hideRecipients && (
        <div className="gmPreview__recipients">
          <div className="gmPreview__title">Recipients</div>
          <AffectedUserList
            affectedUsers={props.affectedUsers}
            affectedUsersCount={props.affectedUsersCount}
            isLoading={props.isResolvingRecipients}
            isLoadingAffectedUserList={props.isLoadingAffectedUserList}
            onLoadAffectedUsers={props.onLoadAffectedUsers}
            isEmailExist={props.isEmailEnabled}
            isPushExist={props.isPushEnabled}
            isSmsExist={props.isSmsEnabled}
          />
        </div>
      )}
    </div>
  );
};

GeneralMessagePreviewWithTabs.displayName = 'GeneralMessagePreviewWithTabs';
